export default __webpack_public_path__ + "static/media/align-justify.048850b2.svg";